import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'

// Lazy load project pages to reduce initial bundle size
const Adobe = lazy(() => import('./pages/Adobe'))
const Organise = lazy(() => import('./pages/Organise'))
const Vault = lazy(() => import('./pages/Vault'))
const Deloitte = lazy(() => import('./pages/Deloitte'))

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/adobe" element={<Adobe />} />
          <Route path="/organise" element={<Organise />} />
          <Route path="/vault" element={<Vault />} />
          <Route path="/deloitte" element={<Deloitte />} />
        </Routes>
      </Suspense>
    </>
  )
}


